// extracted by mini-css-extract-plugin
export default {"path":"Share_path__UFHop","heading":"Share_heading__i-nt6","label":"Share_label__V0A3W","copy_container":"Share_copy_container__y0joK"};